<app-crudbar-nav
  [title]="title"
  [visible]="false"
  (onReady)="doComReady($event, 'crudbar-nav')"
>
</app-crudbar-nav>

<mat-tab-group
  #masterTabGroup
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top"
  animationDuration="0ms"
  dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)"
>
  <mat-tab #myTabGrid label="瀏覽">
    <div class="rounded-box">
      <app-jkaggrid
        #myGrid
        [columnDefs]="srv.columnDefs"
        (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)"
        (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"
      ></app-jkaggrid>
    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細"> </mat-tab>
  <mat-tab #myTabModi label="修改">
    <!-- Toolbar / Header -->
    <div #header class="w-full">
<!--       <app-modal-header
        #modal_header
        [isDialog]="isDialog"
        [state]="state"
        [label]="title"
        (onOkClick)="doOk($event)"
        (onReady)="modalHeaderReady($event)"
        (onCancelClick)="doCancel($event)"
      >
   </app-modal-header>-->
    </div>

    <div class="jk-content">
      <div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jkcheckboxYN
            label="星號"
            #WD027Com
            id="WD027"
            [(valueYN)]="item.WD027"
            [readonly]="isBrowse"
          >
          </app-jkcheckboxYN>
          <app-jkdatefield
            label="工作日期"
            #WD002Com
            id="WD002"
            [(value)]="item.WD002"
            [required]="true"
            placeholder="工作日期"
            [readonly]="isBrowse"
          >
          </app-jkdatefield>
          <app-jkedit
            label="星期"
            #WD018Com
            id="WD018"
            [(value)]="item.WD018"
            placeholder="星期"
            [readonly]="isBrowse"
          >
          </app-jkedit>
          <div class="ai-section-header"><mat-divider></mat-divider></div>
          <div class="flex">
            <app-jkedit
              label="主旨"
              #WD004Com
              id="WD004"
              [(value)]="item.WD004"
              placeholder="主旨"
              [readonly]="isBrowse"
            >
            </app-jkedit>
          </div>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
<!--           <app-easymde-markdown-editor
            [markdown]="content()"
            (markdownChange)="editContent($event)"
            [darkMode]="false"
          ></app-easymde-markdown-editor>
 -->        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex w-full gap-2">
          <app-jkcombobox
            class="flex-1 basis-0 min-w-0"
            label="大分類"
            #WD015Com
            id="WD015"
            [(value)]="item.WD015"
            [items]="srv.MtrWd015List"
            [readonly]="isBrowse"
          >
          </app-jkcombobox>
          <app-jkcombobox
            class="flex-1 basis-0 min-w-0"
            label="中分類"
            #WD016Com
            id="WD016"
            [(value)]="item.WD016"
            [items]="srv.getMtrwd016List(item.WD015)"
            [readonly]="isBrowse"
          >
          </app-jkcombobox>
          <app-jkcombobox
            class="flex-1 basis-0 min-w-0"
            label="小分類"
            #WD024Com
            id="WD024"
            [(value)]="item.WD024"
            [items]="srv.getMtrwd024List(item.WD015, item.WD016)"
            [readonly]="isBrowse"
          >
          </app-jkcombobox>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jkbtnedit
            label="工作者"
            #WD014Com
            id="WD014"
            [(value)]="item.WD014"
            [displayName]="itemAny.WD014C"
            maintable="CMSMV"
            item="W01"
            valueExpr="MV001"
            displayExpr="MV002"
            placeholder="工作者"
            [readonly]="isBrowse"
            (valueChange)="WD014Change($event)"
          >
          </app-jkbtnedit>
          <app-jkbtnedit
            label="客戶代號"
            #WD021Com
            id="WD021"
            [(value)]="item.WD021"
            [required]="true"
            [displayName]="itemAny.WD021C"
            maintable="COPMA"
            item="W01"
            valueExpr="MA001"
            displayExpr="MA002"
            placeholder="客戶代號"
            [readonly]="isBrowse"
            (valueChange)="WD021Change($event)"
          >
          </app-jkbtnedit>
          <app-jknumberedit
            label="計費時數"
            #WD025Com
            id="WD025"
            [(value)]="item.WD025"
            placeholder="計費時數"
            [readonly]="isBrowse"
          >
          </app-jknumberedit>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex gap-2">
          <app-jkcombobox
            class="min-w-20"
            label="狀態"
            #WD011Com
            id="WD011"
            [(value)]="item.WD011"
            [items]="srv.mtrWd011List"
            [readonly]="isBrowse"
          >
          </app-jkcombobox>
          <app-jkcheckboxYN
            label="結案碼"
            #WD017Com
            id="WD017"
            [(valueYN)]="item.WD017"
            [readonly]="isBrowse"
          >
          </app-jkcheckboxYN>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jkcheckboxYN
            label="提醒碼"
            #WD010Com
            id="WD010"
            [(valueYN)]="item.WD010"
            [readonly]="isBrowse"
          >
          </app-jkcheckboxYN>
          <app-jkdatefield
            label="提醒日期"
            #WD005Com
            id="WD005"
            [(value)]="item.WD005"
            placeholder="提醒日期"
            [readonly]="isBrowse"
          >
          </app-jkdatefield>
          <app-jktext label="提醒時間" [value]="item.WD006"> </app-jktext>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jkedit
            label="優先順序"
            #WD012Com
            id="WD012"
            [(value)]="item.WD012"
            placeholder="優先順序"
            [readonly]="isBrowse"
          >
          </app-jkedit>
          <app-jknumberedit
            label="進度"
            #WD013Com
            id="WD013"
            [(value)]="item.WD013"
            placeholder="進度"
            [readonly]="isBrowse"
          >
          </app-jknumberedit>
          <app-jknumberedit
            label="預估時數"
            #WD020Com
            id="WD020"
            [(value)]="item.WD020"
            placeholder="預估時數"
            [readonly]="isBrowse"
          >
          </app-jknumberedit>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jkcheckboxYN
            label="私人的"
            #WD022Com
            id="WD022"
            [(valueYN)]="item.WD022"
            [readonly]="isBrowse"
          >
          </app-jkcheckboxYN>
          <app-jkcombobox
            label="週期"
            #WD023Com
            id="WD023"
            [(value)]="item.WD023"
            [items]="srv.mtrWd023List"
            [readonly]="isBrowse"
          >
          </app-jkcombobox>
          <app-jknumberedit
            label="金額"
            #WD019Com
            id="WD019"
            [(value)]="item.WD019"
            placeholder="金額"
            [readonly]="isBrowse"
          >
          </app-jknumberedit>
        </div>
        <div class="ai-section-header"><mat-divider></mat-divider></div>
        <div class="flex">
          <app-jktext label="來源單號" [value]="item.WD028"> </app-jktext>
          <app-jktext label="建檔時間" [value]="item.WD001"> </app-jktext>
        </div>
      </div>
    </div>
    <mat-toolbar class="jk-footer-toolbar"> </mat-toolbar>
    <!-- 單頭編輯結束 -->
  </mat-tab>
  <mat-tab #myTabAdvance label="進階">
    <div class="card min-h-50 bg-base-100 shadow-sm">
      <div class="card-body">[空白]</div>
    </div>
  </mat-tab>

  <mat-tab label="匯入速記">
    <div class="min-h-50 p-4">
      <div class="card bg-base-100 shadow-sm">
        <div class="card-body gap-4 p-4">
          <div class="card-title">匯入速記</div>
          <div class="flex flex-wrap gap-2">
            <button type="button" class="btn-primary" (click)="importMtrwl()">
              匯入速記
            </button>
          </div>

          @if (importMtrwlError) {
            <div class="alert alert-error">{{ importMtrwlError }}</div>
          } @else if (hasImportedMtrwl) {
            <pre class="overflow-auto rounded-box bg-base-200 p-4 text-sm">{{
              importMtrwlObj | json
            }}</pre>
          }
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
